var RouteService = /** @class */ (function () {
    function RouteService(router) {
        this._router = router;
    }
    RouteService.prototype.recordRoutes = function (path) {
        var routeConfig = this.matchingRouteConfigByPath(path);
        return routeConfig.children;
    };
    RouteService.prototype.matchingRouteConfigByPath = function (startsWith) {
        return this.allRoutes.find(function (route) { return route.path.startsWith(startsWith); });
    };
    Object.defineProperty(RouteService.prototype, "allRoutes", {
        get: function () {
            return this._router.options.routes;
        },
        enumerable: false,
        configurable: true
    });
    return RouteService;
}());
export default RouteService;
